import { IconBase, IconComponent } from './BaseIcon';

export const Italic: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M29.19 3.07A3 3 0 0 0 26.81 2H6.93A4.07 4.07 0 0 0 3 5.3l-.73 4.32 2 .35L5 5.65A2.07 2.07 0 0 1 6.93 4h8.76l-4.12 24H6.34v2h12.37v-2H13.6l4.12-24h9.09a1.07 1.07 0 0 1 .84.35 1.14 1.14 0 0 1 .21.95l-.76 4.32 2 .35.76-4.32a3.14 3.14 0 0 0-.67-2.58z" />
  </IconBase>
);
